import { useAppSelector } from "app/hooks";
import { BMultiSelect } from "components/BMultiSelect";
import { selectActiveAppointmentTypes } from "features/admin/schedule-settings/ScheduleSettings.slice";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface AppointmentTypeMultiSelectProps {
  required?: boolean;
  onChange?: (value: string[] | undefined) => void;
  error?: ReactNode;
  value?: string[]; // could be undefined if form has no initial values
  disabled?: boolean;
}

export const AppointmentTypeMultiSelect = (
  props: AppointmentTypeMultiSelectProps
) => {
  const { t } = useTranslation();
  const aptTypes = useAppSelector(selectActiveAppointmentTypes);

  const data = aptTypes.map((o) => ({ value: o.id, label: o.name }));

  return (
    <BMultiSelect
      {...props}
      label={t("APPOINTMENT_TYPES")}
      nothingFound={t("NOTHING_FOUND")}
      data={data}
    />
  );
};
